import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  InputNumber,
  Button,
  Menu,
  Dropdown,
  Empty,
  DatePicker,
} from "antd";
import { BsCalendar3 } from "react-icons/all";
import "./index.css";
import EtimatedShipingCost from "../../assets/images/estimatedShipingCost.png";
import { useHistory } from "react-router-dom";
import RadioWrapper from "../../components/RadioWrapper";
import moment from "moment";
import LoaderGif from "../../assets/images/ie_loader.gif";
import { numberWithCommas } from "../../config/utils";
import info from "../info";
import CrossIcom from "../../assets/images/cross.png";
import { useSelector } from "react-redux";
import OrderNoteCard from "../OrderNote";
import { TextField } from "@mui/material";


export default function ShoppingCart({
  checkoutScreen,
  productData,
  onChangeCheckoutPayload,
  onSubmitCheckout,
  description,
  placeOrder,
  preferred_delivery_datetimeError,
  clearError,
  onChangeCartQuantity,
  checkoutPayload,
  rmxuser,
  deleteFromCart,
  onbackCatalogScreen,
  onAchDisable,
  dateIndex,
  setDateIndex,
  setPreferedTime,
  preferedTime,
  orderPrice,
  purchaseOrderError,
  onChangeOrderNote,
  billAddress,
  shippAddress,
  currency,
  order_note
}) {

  console.log("purchaseo>", currency);
  const isInitialMount = useRef(true);
  const priceObj = useSelector((store) => store.UserReducer?.priceObj);
  const orderSummary = useSelector((store) => store.UserReducer?.orderData)
  const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem("selectedCurrency") || currency);
  const [currencyFilter, setCurrencyFilter] = useState([]);
  const [isStateClear, setIsStateClear] = useState(false);
  const [filterIndex, setFilterIndex] = useState(0);
  let storedCurrency = localStorage.getItem('selectedCurrency')



  // useEffect(() => {
  //   setSelectedCurrency(currencyFilter[0]?.currency);
  // }, []);

  useEffect(() => {
    let updatedCurrencyFilter = [];

    for (let i in productData) {
      let prices = productData[i]?.rmx_product_prices || [];

      if (prices.length > 0) {
        for (let j in prices) {
          if (prices[j]?.rmx_product_price?.currency) {
            updatedCurrencyFilter.push({ currency: prices[j].rmx_product_price.currency });
          }
        }
      }
      // else {
      // updatedCurrencyFilter.push({ currency: "$" });
      // }
    }
    const uniqueCurrencies = updatedCurrencyFilter.filter(
      (value, index, self) =>
        index === self.findIndex((obj) => obj.currency === value.currency)
    );
    setCurrencyFilter(uniqueCurrencies);

    console.log("uniqueCurrencies", uniqueCurrencies)

    // a case to check if only one currency left then that would be selected automatically in the select box and for the products as well.
    if (uniqueCurrencies?.length == 1) {
      localStorage.setItem("selectedCurrency", uniqueCurrencies?.[0]?.currency)
      setSelectedCurrency(uniqueCurrencies?.[0]?.currency)
    }

    if (productData?.length !== 0) {
      setSelectedCurrency(localStorage.getItem("selectedCurrency"))
    }
    else {
      setIsStateClear(true)
    }

  }, [productData]);


  console.log('currencyFilter', currencyFilter);


  useEffect(() => {
    // localStorage.setItem("selectedCurrency", "USD");
    let data;
    if (localStorage?.getItem("cart")) {
      data = JSON.parse(localStorage?.getItem("cart"));
    }

    if (data) {
      const previousData = (data || []).map((item) => {
        return {
          price: item.actualProdcutPrice,
          quantity: item?.quantity,
          rmx_product_id: item?.id,
          order_product_additive: item?.rmx_product_additives
            ?.filter((v) => v?.selected)
            .map((c) => {
              return {
                selected: 1,
                rmx_product_additive_id: c.id,
              };
            }),
        };
      });

      let Obj = {
        order_product: [...previousData],
        preferred_delivery_datetime: "",
        preferred_delivery_period: "pm",
        rmx_company_id: rmxuser?.id,
        purchase_order_num: "",
      };
      if (orderPrice) {
        orderPrice(Obj);
      }
    }

    // const data =
  }, []);


  useEffect(() => {
    console.log("storedCurrency", storedCurrency)
    if (currencyFilter && currencyFilter?.length > 0 && !checkoutScreen && !storedCurrency) {
      console.log("currentSelectedd", currencyFilter[filterIndex])
      setSelectedCurrency(currencyFilter[filterIndex || 0]?.currency)
      localStorage.setItem("selectedCurrency", currencyFilter[filterIndex || 0]?.currency);
    }
    else if (!checkoutScreen && !storedCurrency) {
      // localStorage.setItem("selectedCurrency", "USD");
    }
  }, [currencyFilter])


  useEffect(() => {
    if (isStateClear && productData?.length == 0) {
      console.log('products length check ====', productData)
      localStorage.removeItem("selectedCurrency")
      setSelectedCurrency("");
      setCurrencyFilter([]);
      setIsStateClear(false)
    }
  }, [isStateClear])


  let dateFormat = moment(new Date()).format("YYYY-MM-DD")
  const [radioValue, setRadioValue] = useState(preferedTime);
  const [date, setDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [defaultDate, setDefaultDate] = useState(checkoutPayload?.preferred_delivery_datetime ?
    checkoutPayload?.preferred_delivery_datetime.split(" ")[0] : dateFormat);

  console.log("dateeeeeeeeeeee", defaultDate, checkoutPayload?.preferred_delivery_datetime);
  const [ordrNoteDescription, setOrdrNoteDescription] = useState("");
  let datePrev = moment(checkoutPayload?.preferred_delivery_datetime)
  console.log("checkdatttt", datePrev?._d);


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      clearError();
      // Your useEffect code here to be run on update
      onChangeCheckoutPayload(
        "preferred_delivery_datetime",
        moment(date).format("YYYY-MM-DD HH:mm:ss")
      );
    }

  }, [date]);
  useEffect(() => { }, [productData]);

  useEffect(() => {
    if (checkoutPayload.preferred_delivery_datetime) {
      setDate(moment(checkoutPayload.preferred_delivery_datetime).format('ll'))
    }
  }, []);

  const onChange = (date, dateString) => {
    // console.log('DATE_TIME==>',moment().diff(dateString,"days"))
    const checkDiff = moment().diff(dateString, "days");
    if (checkDiff === -1 || checkDiff === -2) {
      info(
        "warning",
        "ACH Payments is not available for orders to be delivered within 4 days"
      );
      onAchDisable(false);
      setDate(date);
      setIsOpen(false);
    } else {
      onAchDisable(true);
      setDate(date);
      setIsOpen(false);
    }
  };

  const onChangeFilter = (e) => {
    //  console.log("onChangeFilter", e);
    setSelectedCurrency(e);
    localStorage.setItem("selectedCurrency", e);
  }

  //  console.log("selectedCurrency", selectedCurrency);


  const isLoader = useSelector((store) => store.UserReducer.isCreateOrder);
  const isPlaceOrder = useSelector((store) => store?.UserReducer?.isPostCharge);

  // helper to safely convert to number
  const toNum = (v) => Number(v ?? 0) || 0;

  function getItemPrice(item, selectedCurrency) {
    const prices = item?.rmx_product_prices ?? [];
    if (prices.length > 0) {
      // Case 1: price list exists -> only accept exact currency match
      const found = prices.find(p => p?.rmx_product_price?.currency === selectedCurrency);
      if (found && found.rmx_product_price && typeof found.rmx_product_price.price !== 'undefined' && found.rmx_product_price.price !== null) {
        return toNum(found.rmx_product_price.price);
      }
      // price list exists but selectedCurrency not supported -> price 0
      return 0;
    }

    // Case 2: no price list at all -> USD fallback only
    if (selectedCurrency === 'USD' || selectedCurrency === '$') {
      return toNum(item?.actualProdcutPrice ?? item?.price ?? 0);
    }

    return 0;
  }

  // compute subtotal once (not inside JSX)
  const subtotal = (productData || []).reduce((total, item) => {
    const price = getItemPrice(item, selectedCurrency);

    // if currency not supported (price === 0) we skip this item completely (including additive)
    if (price === 0) return total;

    const additive = toNum(item?.selectedAditivePrice);
    const quantity = toNum(item?.quantity);

    return total + (price + additive) * quantity;
  }, 0);

  const grandTotal = toNum(priceObj?.shipping_amount) + subtotal;


  return (
    <Row
      justify="end"
      style={{ marginTop: "5px", padding: "15px" }}
    // onClick={() => setIsOpen(false)}
    >
      {!!productData?.length ? (
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Row justify="start">
            <Col span={24}>
              <Row justify="center">
                <Col
                  span={24}
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                >
                  {checkoutScreen ? (
                    <h2 className="text-left checkout-heading">{`Checkout`}</h2>
                  ) : (
                    <h2 className="text-left checkout-heading">{`Shopping Cart`}</h2>
                  )}
                </Col>
              </Row>

              {!checkoutScreen &&

                <Row justify="end" className="currency-filters">
                  <Col span={12} className="text-right">
                    <span className="currency-filters-heading">Select Currency</span>

                    <select
                      className=""
                      onChange={(e) => onChangeFilter(e.target.value)}
                      value={selectedCurrency}
                      // value={selectedCurrency}
                      defaultValue={currencyFilter[0]?.currency}
                    >
                      {currencyFilter.length > 0 &&
                        currencyFilter?.map((item) => {
                          return (
                            <option value={item.currency}>{item.currency}</option>
                          );
                        })}
                    </select>
                  </Col>

                </Row>
              }
              <Row justify="center">
                <Col span={24}>
                  <Card className="shoping-card">
                    <Row justify="start">
                      {checkoutScreen && (
                        <Col span={24} style={{ marginTop: "-20px" }}>
                          <h4 className="text-left checkout-orderreview">{`Order Review`}</h4>
                        </Col>
                      )}

                      {checkoutScreen &&
                        (productData || []).map((item) => {
                          console.log("ProductData===>", item);
                          const price = item?.rmx_product_prices?.length
                            ? item.rmx_product_prices.find(({ rmx_product_price: i }) => i?.currency === selectedCurrency)
                              ?.rmx_product_price?.price || 0
                            : selectedCurrency === "$" || selectedCurrency === "USD"
                              ? item?.actualProdcutPrice || item?.price || 0
                              : 0;
                          return (
                            <>
                              <Col span={17}>
                                <Row
                                  justify="start"
                                  style={{
                                    paddingLeft: "2px",
                                  }}
                                  align="middle"
                                >
                                  <Col
                                    span={24}
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    <Row>
                                      <Col
                                        span={3}
                                        xl={3}
                                        xs={6}
                                        className="text-left"
                                        style={{
                                          height: "52px",
                                          width: "52px",
                                          border: "1px solid edeff0",
                                          backgroundPosition: "center center",
                                          backgroundSize: "cover",
                                          backgroundRepeat: "no-repeat",
                                          backgroundImage: `url(${item?.image?.original})`,
                                        }}
                                      ></Col>
                                      <Col
                                        span={12}
                                        xl={20}
                                        xs={18}
                                        className="text-left"
                                        style={{
                                          paddingLeft: "10px ",
                                        }}
                                      >
                                        <span className="text-left checkout-text">
                                          <span>{item?.name}</span>
                                          <br></br>
                                          <span
                                            className="text-left "
                                            style={{
                                              fontSize: "1.1rem",
                                              lineHeight: "1px",
                                              fontWeight: "300",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {selectedCurrency + " "}
                                            {/* {numberWithCommas(
                                              Number(
                                                item?.actualProdcutPrice +
                                                item?.selectedAditivePrice
                                              ).toFixed(2)
                                            )} */}
                                            {/* {numberWithCommas(
                                              Number(
                                                price
                                              ).toFixed(2)
                                            )} */}
                                            {Number(price) + Number(item?.selectedAditivePrice)}


                                            <span
                                              style={{
                                                padding: "5px",
                                                fontSize: "1rem",
                                              }}
                                            >
                                              X
                                            </span>
                                            <span>
                                              {item?.quantity} {item?.unit}
                                            </span>
                                          </span>
                                          <span
                                            className="text-left checkout-num"
                                            style={{ float: "right" }}
                                          >
                                            {/* ${Number(item.price * item.quantity).toFixed(2)} */}
                                            {selectedCurrency + " "}
                                            {/* {item?.selectedAditivePrice
                                              ? numberWithCommas(
                                                Number(
                                                  (item?.selectedAditivePrice +
                                                    item?.actualProdcutPrice) *
                                                  item.quantity
                                                ).toFixed(2)
                                              )
                                              : numberWithCommas(
                                                Number(
                                                  item.quantity *
                                                  item.actualProdcutPrice
                                                ).toFixed(2)
                                              )} */}
                                            {
                                              numberWithCommas(Number(price * item.quantity + item?.selectedAditivePrice * item.quantity).toFixed(2))
                                            }
                                            {/* {(productData || [])
                                              .reduce((pre, item) => {
                                                return (
                                                  item?.selectedAditivePrice ? Number(pre) + Number((item?.actualProdcutPrice + item?.selectedAditivePrice) * item.quantity)
                                                    :
                                                    Number(pre) + Number(item.quantity * item.actualProdcutPrice)
                                                  // Number(item.price * item.quantity)
                                                );
                                              }, 0)
                                              .toFixed(2)} */}
                                          </span>
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              {/* <Col className="text-left">
                                <Row
                                  justify="start"
                                  align="bottom"
                                  style={{ marginTop: "30px" }}
                                >
                                  <Col span={24} className="checkout-num">
                                    $
                                    {Number(item.price * item.quantity).toFixed(
                                      2
                                    )}
                                  </Col>
                                </Row>
                              </Col> */}
                            </>
                          );
                        })}
                      {(productData || []).map((item, index) => {
                        // Normalize USD/$ → treat them the same
                        const normalizeCurrency = (currency) => {
                          if (currency === "$") return "USD";
                          return currency;
                        };

                        const normalizedSelected = normalizeCurrency(selectedCurrency);

                        // Step 1: Check normally in rmx_product_prices
                        let hasSelectedCurrency = item?.rmx_product_prices?.some(
                          ({ rmx_product_price }) =>
                            normalizeCurrency(rmx_product_price?.currency) === normalizedSelected
                        );

                        // Step 2: Special case → empty rmx_product_prices but product has price key
                        if ((!item?.rmx_product_prices || item.rmx_product_prices.length === 0) && item?.price) {
                          if (normalizedSelected === "USD") {
                            hasSelectedCurrency = true;
                          }
                        }

                        let supportedCurrencies = ["USD", "CA$", "EUR"]; // normalized list

                        // Step 3: Final error check
                        let showCurrencyError =
                          !hasSelectedCurrency || !supportedCurrencies.includes(normalizedSelected);

                        console.log(showCurrencyError);

                        const matchingPrice = item?.rmx_product_prices?.find(
                          ({ rmx_product_price }) => rmx_product_price?.currency === selectedCurrency
                        );

                        // let additive = item?.selectedAditivePrice || 0;
                        // const quantity = item?.quantity || 0;

                        // let price = 0;

                        // // Case 1: When rmx_product_prices exist
                        // if (item?.rmx_product_prices?.length) {
                        //   const found = item.rmx_product_prices.find(
                        //     ({ rmx_product_price: i }) => i?.currency === selectedCurrency
                        //   );

                        //   if (found?.rmx_product_price?.price) {
                        //     price = found.rmx_product_price.price;
                        //   } else if (
                        //     !found?.rmx_product_price?.price &&
                        //     (selectedCurrency === "USD" || selectedCurrency === "$")
                        //   ) {
                        //     price =
                        //       item.rmx_product_prices.find(
                        //         ({ rmx_product_price: i }) =>
                        //           i?.currency === "USD" || i?.currency === "$"
                        //       )?.rmx_product_price?.price ||
                        //       item?.actualProdcutPrice ||
                        //       item?.price ||
                        //       0;
                        //   } else {
                        //     // return null; 
                        //     additive = 0;
                        //   }
                        // } else {
                        //   // Case 2: Fallback if no rmx_product_prices at all
                        //   if (selectedCurrency === "$" || selectedCurrency === "USD") {
                        //     price = item?.actualProdcutPrice || item?.price || 0;
                        //   } else {
                        //     // return null; 
                        //     additive = 0;
                        //   }
                        // }

                        // new code
                        let additive = item?.selectedAditivePrice || 0;
                        const quantity = item?.quantity || 0;
                        let price = 0;

                        // Case 1: When rmx_product_prices exist
                        if (item?.rmx_product_prices?.length) {
                          const found = item.rmx_product_prices.find(
                            ({ rmx_product_price: i }) => i?.currency === selectedCurrency
                          );

                          if (found?.rmx_product_price?.price) {
                            // ✅ Supported currency → use its price
                            price = found.rmx_product_price.price;
                          } else {
                            // ❌ Currency not supported → set to 0
                            price = 0;
                            additive = 0;
                          }
                        } else {
                          // Case 2: No rmx_product_prices at all
                          if (item?.actualProdcutPrice || item?.price) {
                            // ✅ Treat existing raw price as USD
                            if (selectedCurrency === "USD" || selectedCurrency === "$") {
                              price = item?.actualProdcutPrice || item?.price || 0;
                            } else {
                              price = 0;
                              additive = 0;
                            }
                          } else {
                            // ❌ No price field at all
                            price = 0;
                            additive = 0;
                          }
                        }

                        return (
                          !checkoutScreen && (
                            <>
                              <Row
                                style={{ width: "100%", marginBottom: showCurrencyError ? "0px" : "20px" }}
                              >
                                <Col
                                  span={2}
                                  // lg={2}
                                  // md={2}
                                  // xs={4}
                                  // sm={4}
                                  style={{
                                    backgroundImage: `url(${item?.image?.original})`,
                                    marginBottom: "15px",
                                    width: "52px",
                                    height: "52px",
                                    border: "1px solid #edeff0",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    margin: "0px",
                                    backgroundPosition: "center center",
                                  }}
                                ></Col>
                                <Col span={9}>
                                  <h2
                                    className="text-left checkout-text"
                                    style={{
                                      paddingLeft: "10px",
                                      paddingTop: "10px",
                                      float: "left",
                                    }}
                                  >
                                    {item.name}
                                  </h2>
                                </Col>

                                <Col span={13}>
                                  <Row
                                    style={{
                                      alignItems: "center",
                                      padding: "10px",
                                    }}
                                    justify="end"
                                  >
                                    <Col
                                      span={24}
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <span
                                        className="checkout-num"
                                        style={{ float: "right" }}
                                      >
                                        <span>
                                          <InputNumber
                                            value={item.quantity}
                                            // value={2}
                                            onChange={(e) => {
                                              setFilterIndex(currencyFilter.findIndex(item => item?.currency == selectedCurrency));
                                              onChangeCartQuantity(e, index);
                                            }}
                                            type="number"
                                          />
                                        </span>
                                        <span
                                          style={{
                                            paddingLeft: "12px",
                                            paddingRight: "5px",
                                          }}
                                        >
                                          {item.unit}
                                        </span>
                                        <span
                                          style={{
                                            paddingLeft: "5px",
                                            paddingRight: "5px",
                                          }}
                                        >
                                          =
                                        </span>
                                        <span
                                          style={{ marginLeft: "10px" }}
                                        >

                                          {/* 
                                          {
                                            matchingPrice
                                              ? `${matchingPrice.rmx_product_price.currency} ${numberWithCommas(
                                                (matchingPrice?.rmx_product_price?.price * item?.quantity + item?.quantity * item?.selectedAditivePrice ).toFixed(2)
                                              )}`
                                              : selectedCurrency == '$' || selectedCurrency == 'USD'
                                                ? `
                                                  ${selectedCurrency}
                                                  ${item?.selectedAditivePrice
                                                  ? numberWithCommas(
                                                    Number(
                                                      Number(
                                                        (item?.selectedAditivePrice* item?.quantity +
                                                          item?.actualProdcutPrice * item.quantity) 
                                                      )
                                                    ).toFixed(2)
                                                  )
                                                  : numberWithCommas(
                                                    Number(
                                                      Number(
                                                        item.quantity *
                                                        item.actualProdcutPrice
                                                      )
                                                    ).toFixed(2)
                                                  )
                                                }`
                                                : ""
                                              

                                          } */}

                                          {`${selectedCurrency} ${numberWithCommas(
                                            (quantity * price + quantity * additive).toFixed(2)
                                          )}`}

                                        </span>
                                        <span
                                          className="pointer-cursor"
                                          onClick={() => deleteFromCart(index)}
                                          style={{
                                            paddingLeft: "20px",
                                            paddingRight: "20px",
                                          }}
                                        >
                                          <img
                                            src={CrossIcom}
                                            className="cross-img pointer-cursor"
                                          />
                                        </span>
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              {showCurrencyError && (
                                <Row className="currency-error">
                                  <Col span={24}>
                                    <span>This product is not available in selected currency</span>
                                  </Col>
                                </Row>
                              )}

                            </>
                          )
                        );
                      })}
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                {checkoutScreen && (
                  <Col span={12}>
                    <Row justify="start">
                      <Col
                        span={24}
                        style={{
                          border: "1px solid #09c1b2",
                          padding: "0.5rem",
                          // minHeight: "191px",
                          // maxHeight: "191px",
                          marginBottom: "20px",
                          marginTop: "8px",
                          // visibility: !description ? "hidden" : "visible",
                        }}
                      >
                        <Row justify="start">
                          {!checkoutScreen && (
                            <Col span={6} style={{ position: "relative" }}>
                              <img
                                src={EtimatedShipingCost}
                                style={{
                                  width: "180%",
                                  position: "absolute",
                                  backgroundRepeat: "no-repeat",
                                  top: "-22px",
                                  display: "flex",
                                }}
                              />
                            </Col>
                          )}
                          {/* {checkoutScreen && (

                           

                          )} */}


                          {/* <Col
                            xl={17}
                            lg={17}
                            xs={24}
                            sm={18}
                            md={17}
                          >
                            <OrderNoteCard
                              // mainHeading={"Checkout"}
                              // onSubmitNote={this.onSubmitNote}
                              // onChangeOrderNote={this.onChangeOrderNote}
                              order_note={"this.state.order_note"}
                            />
                          </Col> */}


                          {/* )} */}


                          {checkoutScreen &&
                            <Row>

                              <Col span={24} className="text-left" style={{
                                paddingLeft: "9px",
                                fontWeight: "600"

                              }}>
                                <label
                                  className="text-left"
                                  style={{ fontSize: "0.8rem" }}
                                >{`ORDER SUMMARY`}</label>
                              </Col>


                              <Col
                                span={24}
                                style={{
                                  // border: "1px solid #09c1b2",
                                  // marginTop: "15px",
                                  marginBottom: "10px"

                                }}
                              >
                                <Row
                                  justify="start"
                                  align="middle"
                                  className="grandtotalcard-padding"
                                >
                                  <Col span={11} className="text-left total-color">
                                    Shipping Addres
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col span={10} style={{ textAlign: "start" }}>
                                    {shippAddress}
                                  </Col>
                                </Row>

                                <Row justify="start" className="grandtotalcard-padding">
                                  <Col span={11} className="text-left total-color">
                                    Billing Address
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col span={10} style={{ textAlign: "start" }}>
                                    {billAddress}
                                  </Col>
                                </Row>



                                <Row justify="start " className="grandtotalcard-padding">
                                  <Col span={11} className="text-left total-color">
                                    Expedite Order Date
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col span={10} style={{ textAlign: "start" }}>

                                    {
                                      orderSummary?.preferred_delivery_datetime.split(" ")[0]
                                    }
                                  </Col>
                                </Row>

                                <Row justify="start " className="grandtotalcard-padding">
                                  <Col span={11} className="text-left total-color">
                                    PO#
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col span={10} style={{ textAlign: "start" }}>
                                    {
                                      orderSummary?.purchase_order_num ? orderSummary?.purchase_order_num : "-"
                                    }
                                  </Col>
                                </Row>

                                {/* <Row justify="start " className="grandtotalcard-padding">
                                  <Col span={11} className="text-left total-color">
                                    Order 
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col span={10} className="text-right">

                                  </Col>
                                </Row> */}


                                {/* <Row justify="start" className="grandtotalcard-padding">
                                  <Col span={11} className="text-left">
                                    Date
                                  </Col>
                                  <Col span={2} className="text-left">
                                    =
                                  </Col>
                                  <Col
                                    span={10}
                                    className="text-right total-color"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    $
                                    {numberWithCommas(
                                      (
                                        (priceObj?.shipping_amount || 0) +
                                        (productData || []).reduce((pre, item) => {
                                          return (

                                            item?.selectedAditivePrice
                                              ? Number(pre) +
                                              Number(
                                                (item?.selectedAditivePrice +
                                                  item?.actualProdcutPrice) *
                                                item.quantity
                                              )
                                              : Number(pre) +
                                              Number(
                                                item.quantity *
                                                item.actualProdcutPrice
                                              )
                                          );
                                        }, 0)
                                      ).toFixed(2)
                                    )}
                                  </Col>
                                </Row> */}

                              </Col>










                              <Col span={24} className="text-left"
                                style={{
                                  paddingLeft: "10px",
                                  fontWeight: "600"
                                }}
                              >
                                <label
                                  className="text-left"
                                  style={{ fontSize: "0.8rem" }}
                                >{`ORDER NOTES`}</label>
                              </Col>
                              <Col
                                span={24}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  marginBottom: "10px",
                                  paddingLeft: "10px",
                                }}
                                className="text-left"
                              >

                                {/* <OrderNoteCard
                              // mainHeading={"Checkout"}
                              // onSubmitNote={this.onSubmitNote}
                              // onChangeOrderNote={this.onChangeOrderNote}
                              order_note={"this.state.order_note"}
                            /> */}

                                <TextField
                                  name="description"
                                  placeholder="Add Order Notes (if any).."
                                  multiline
                                  rows={2}
                                  variant="standard"
                                  inputProps={{ maxLength: 255 }}
                                  InputLabelProps={{
                                    style: { color: "#26a69a" },
                                  }}
                                  sx={{
                                    "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
                                      color: "orange",
                                    },
                                  }}
                                  value={description}
                                  onChange={(e) => {
                                    onChangeOrderNote(e);
                                    // setCount(255 - e.target.value.length);
                                  }}
                                  // onChange={(description) =>
                                  //   setAddBasemix({
                                  //     ...addBasemix,
                                  //     description: description.target.value,
                                  //   })
                                  // }
                                  // value={addBasemix.description}
                                  fullWidth={true}
                                />


                                {/* <span
                              style={{
                                fontSize: "12px",
                                color: "black",
                                wordBreak: "break-all",
                              }}
                            >
                             
                              
                            </span> */}
                              </Col>





                            </Row>

                          }
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                {!checkoutScreen && (
                  <Col span={12} style={{ marginTop: "8px" }}>
                    <Row justify="center">
                      <Col
                        span={24}
                        style={{
                          border: "1px solid #F0F0F0",
                          padding: "0.5rem",
                          minHeight: "191px",
                          maxHeight: "191px",
                          marginBottom: "20px",
                        }}
                      >
                        <Row justify="start">
                          <Col span={6} style={{ position: "relative" }}>
                            <img
                              src={EtimatedShipingCost}
                              style={{
                                position: "absolute",
                                backgroundRepeat: "no-repeat",
                                top: "-21px",
                                display: "flex",
                                left: "5px",
                              }}
                            />
                          </Col>
                          <Col span={24} style={{ marginTop: "1.5rem" }}>
                            <Row
                              // justify="space-between"
                              className="grandtotalcard-padding"
                            >
                              <Col
                                span={12}
                                xl={11}
                                xs={10}
                                className="text-left"
                              >
                                Purchase Order#
                              </Col>
                              <Col
                                span={12}
                                sm={12}
                                xs={13}
                                md={12}
                                xll={12}
                                xl={13}
                                lg={12}
                                className="text-right"
                              >
                                <input
                                  placeholder="eg.12345"
                                  name="purchase_order_num"
                                  onChange={(e) =>
                                    onChangeCheckoutPayload(
                                      e.target.name,
                                      e.target.value
                                    )
                                  }
                                  maxlength="10"
                                  type="string"
                                  value={checkoutPayload.purchase_order_num}
                                  style={{ outline: "none" }}
                                />
                              </Col>
                              <Col span={24}>
                                <Row>
                                  <Col span={24}>
                                    <p
                                      className="text-right danger-color "
                                      style={{
                                        fontSize: "0.8rem",
                                        marginBottom: "-15px",
                                      }}
                                    >
                                      {purchaseOrderError}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row
                              justify="space-between"
                              className="grandtotalcard-padding"
                              style={{ height: "66px" }}
                            >
                              <Col span={10} className="text-left">
                                Preferred Date{" "}
                              </Col>
                              <Col
                                span={5}
                                // xxl={8}
                                className="text-right"
                                style={{
                                  justifyContent: "end",
                                  height: preferred_delivery_datetimeError
                                    ? 0
                                    : "auto",
                                }}
                              >
                                <BsCalendar3
                                  size={20}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpen(!isOpen);
                                  }}
                                />
                                <DatePicker
                                  open={isOpen}
                                  onChange={onChange}
                                  className={"custom-picker"}
                                  disabledDate={(current) => {
                                    let customDate = moment()
                                      .add(2, "days")
                                      .format("YYYY-MM-DD");
                                    return (
                                      current &&
                                      current < moment(customDate, "YYYY-MM-DD")
                                    );
                                  }}
                                  // value={date}
                                  defaultValue={datePrev?._d == "Invalid Date" ? moment(new Date()) : datePrev}
                                  allowClear={false}
                                  bordered={false}
                                />
                              </Col>

                              {date && (
                                <Col
                                  span={8}
                                  xxl={5}
                                  style={{
                                    border: "solid grey 1px ",
                                    height: "27px",
                                  }}
                                >
                                  {moment(date).format("ll")}
                                </Col>
                              )}

                              {/* <Col
                                span={8}
                                xxl={5}
                                style={{
                                  border: "solid grey 1px ",
                                  height: "27px",
                                }}
                              >
                                {moment(date).format("ll")}

                              </Col> */}

                              {/* {checkoutPayload?.preferred_delivery_datetime ?
                                <Col
                                  span={6}
                                  xxl={5}
                                  style={{
                                    border: "solid grey 1px ",
                                    height: "27px",
                                  }}
                                >
                                  {
                                    // datePrev ? datePrev : checkoutPayload?.preferred_delivery_datetime ?
                                    //   checkoutPayload?.preferred_delivery_datetime?.split(" ")[0] : dateFormat
                                    // datePrev == "Invalid date" ? "in" : "out"
                                  }
                                </Col>
                                : ""
                              } */}
                              {/* <BsCalendar3
                                size={20}
                               
                              /> */}
                              <Col span={24}>
                                <Row>
                                  <Col span={24}>
                                    <p
                                      className="text-right danger-color "
                                      style={{
                                        fontSize: "0.8rem",
                                        marginBottom: "-15px",
                                      }}
                                    >
                                      {preferred_delivery_datetimeError}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row
                              justify="start"
                              className="grandtotalcard-padding"
                            >
                              <Col span={16} className="text-left">
                                Expedite Order{" "}
                              </Col>
                              <Col span={4}>
                                <RadioWrapper
                                  name="am"
                                  value={"am"}
                                  checked={radioValue === "am"}
                                  onChange={(e) => {
                                    setRadioValue("am");
                                    onChangeCheckoutPayload(
                                      "preferred_delivery_period",
                                      e.target.value
                                    );
                                    setPreferedTime(e.target.value);
                                  }}
                                />
                                <span>Yes</span>{" "}
                              </Col>
                              <Col span={4}>
                                <RadioWrapper
                                  name="pn"
                                  value={"pm"}
                                  checked={radioValue === "pm"}
                                  onChange={(e) => {
                                    setRadioValue("pm");
                                    onChangeCheckoutPayload(
                                      "preferred_delivery_period",
                                      e.target.value
                                    );
                                    setPreferedTime(e.target.value);
                                  }}
                                />
                                <span>No</span>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                <Col span={11} style={{ marginTop: "8px" }}>
                  <Row justify="start">
                    <Col
                      span={24}
                      style={{
                        border: "1px solid #09c1b2",
                        minHeight: "191px",
                        maxHeight: "191px",
                      }}
                    >
                      <Row
                        justify="start"
                        align="middle"
                        className="grandtotalcard-padding"
                      >
                        <Col span={11} className="text-left total-color">
                          Subtotal
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          {selectedCurrency + " "}
                          {/* {numberWithCommas(
                            (productData || [])
                              .reduce((pre, item) => {
                                return item?.selectedAditivePrice
                                  ? Number(pre) +
                                  Number(
                                    (item?.selectedAditivePrice +
                                      item?.actualProdcutPrice) *
                                    item.quantity
                                  )
                                  : Number(pre) +
                                  Number(
                                    item.quantity * item.actualProdcutPrice
                                  );
                                // // Number(item.price * item.quantity)
                              }, 0)
                              .toFixed(2)
                          )} */}
                          {/* {numberWithCommas(
                            ((productData || []).reduce((total, item) => {
                              let price = 0;

                              // Case 1: Use rmx_product_prices if available
                              if (item?.rmx_product_prices?.length) {
                                const found = item.rmx_product_prices.find(
                                  ({ rmx_product_price: i }) => i?.currency === selectedCurrency
                                );

                                if (found?.rmx_product_price?.price) {
                                  price = found?.rmx_product_price?.price;
                                }
                                else if (!found?.rmx_product_price?.price && (selectedCurrency == "USD" || selectedCurrency == "$")) {
                                  price = item.rmx_product_prices.find(
                                    ({ rmx_product_price: i }) => i?.currency === "USD" || i?.currency === "$"
                                  )?.rmx_product_price?.price || item?.actualProdcutPrice || item?.price || 0;
                                }
                                else if (!found?.rmx_product_price?.price) {
                                  return total;
                                }

                              } else {
                                // Case 2: Fallback for USD or $
                                if (selectedCurrency === "$" || selectedCurrency === "USD") {
                                  price = item?.actualProdcutPrice || item?.price || 0;
                                } else {
                                  return total;
                                }
                              }

                              const additive = item?.selectedAditivePrice || 0;
                              const quantity = item?.quantity || 0;

                              return total + (quantity * price + quantity * additive);
                            }, 0)).toFixed(2)
                          )} */}
                          {numberWithCommas(subtotal.toFixed(2))}

                        </Col>
                      </Row>

                      <Row justify="start" className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          Expedite Order Cost
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          {selectedCurrency + " "}
                          {numberWithCommas(
                            priceObj?.shipping_amount?.toFixed(2) || 0
                          )}
                          {/* {numberWithCommas(priceObj?.shipping_amount).toFixed(
                            2
                          )} */}
                        </Col>
                      </Row>
                      <Row justify="start " className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          Tax
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          {/* tax_amount */}{selectedCurrency + " "}
                          {priceObj?.tax_amount
                            ? numberWithCommas(
                              priceObj?.tax_amount || 0
                            ).toFixed(2)
                            : "0.00"}
                        </Col>
                      </Row>
                      <Row justify="start" className="grandtotalcard-padding">
                        <Col span={11} className="text-left">
                          Grand Total
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col
                          span={10}
                          className="text-right total-color"
                          style={{ fontWeight: "bold" }}
                        >
                          {/* {selectedCurrency + " "} */}
                          {/* {numberWithCommas(
                            (
                              (priceObj?.shipping_amount || 0) +
                              (productData || []).reduce((pre, item) => {
                                return (
                                  // Number(pre) + Number(item.price * item.quantity)
                                  item?.selectedAditivePrice
                                    ? Number(pre) +
                                    Number(
                                      (item?.selectedAditivePrice +
                                        item?.actualProdcutPrice) *
                                      item.quantity
                                    )
                                    : Number(pre) +
                                    Number(
                                      item.quantity *
                                      item.actualProdcutPrice
                                    )
                                );
                              }, 0)
                            ).toFixed(2)
                          )} */}
                          {/* {numberWithCommas(
                            ((priceObj?.shipping_amount || 0) +
                              (productData || [])
                                .reduce((total, item) => {
                                  let price = 0;

                                  // Case 1: Use rmx_product_prices if available
                                  if (item?.rmx_product_prices?.length) {
                                    const found = item.rmx_product_prices.find(
                                      ({ rmx_product_price: i }) => i?.currency === selectedCurrency
                                    );

                                    if (found?.rmx_product_price?.price) {
                                      price = found?.rmx_product_price?.price;
                                    }
                                    else if (!found?.rmx_product_price?.price && (selectedCurrency == "USD" || selectedCurrency == "$")) {
                                      price = item.rmx_product_prices.find(
                                        ({ rmx_product_price: i }) => i?.currency === "USD" || i?.currency === "$"
                                      )?.rmx_product_price?.price || item?.actualProdcutPrice || item?.price || 0;
                                    }
                                    else if (!found?.rmx_product_price?.price) {
                                      return total;
                                    }

                                  } else {
                                    // Case 2: Fallback for USD or $
                                    if (selectedCurrency === "$" || selectedCurrency === "USD") {
                                      price = item?.actualProdcutPrice || item?.price || 0;
                                    } else {
                                      return total;
                                    }
                                  }

                                  const additive = item?.selectedAditivePrice || 0;
                                  const quantity = item?.quantity || 0;

                                  return total + (quantity * price + quantity * additive);
                                }, 0))
                              .toFixed(2)
                          )} */}
                          {selectedCurrency + " "}
                          {numberWithCommas(grandTotal.toFixed(2))}
                        </Col>
                      </Row>
                    </Col>
                    {/* { */}
                    {/* checkoutScreen &&
                    <Col
                      span={24}
                      style={{
                        border: "1px solid #09c1b2",
                        marginTop: "15px",
                        marginBottom: "10px"

                      }}
                    >

                      <Row
                        justify="start"
                        align="middle"
                        className="grandtotalcard-padding"
                      >
                        <Col span={11} className="text-left total-color">
                          Shipping Addres
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          $
                          {numberWithCommas(
                            (productData || [])
                              .reduce((pre, item) => {
                                return item?.selectedAditivePrice
                                  ? Number(pre) +
                                  Number(
                                    (item?.selectedAditivePrice +
                                      item?.actualProdcutPrice) *
                                    item.quantity
                                  )
                                  : Number(pre) +
                                  Number(
                                    item.quantity * item.actualProdcutPrice
                                  );

                              }, 0)
                              .toFixed(2)
                          )}
                        </Col>
                      </Row>

                      <Row justify="start" className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          Billing Address
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          $
                          {numberWithCommas(
                            priceObj?.shipping_amount?.toFixed(2) || 0
                          )}

                        </Col>
                      </Row>
                      <Row justify="start " className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          PO#
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          {
                            orderSummary?.purchase_order_num ? orderSummary?.purchase_order_num : "-"
                          }
                        </Col>
                      </Row>


                      <Row justify="start " className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          Payment Method
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">

                          {priceObj?.tax_amount
                            ? numberWithCommas(
                              priceObj?.tax_amount || 0
                            ).toFixed(2)
                            : "0.00"}
                        </Col>
                      </Row>

                      <Row justify="start " className="grandtotalcard-padding">
                        <Col span={11} className="text-left total-color">
                          Expedite Order
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col span={10} className="text-right">
                          {/* tax_amount */}
                    {/* {priceObj?.tax_amount
                            ? numberWithCommas(
                              priceObj?.tax_amount || 0
                            ).toFixed(2)
                            : "0.00"}
                        </Col>
                      </Row>


                      <Row justify="start" className="grandtotalcard-padding">
                        <Col span={11} className="text-left">
                          Date
                        </Col>
                        <Col span={2} className="text-left">
                          =
                        </Col>
                        <Col
                          span={10}
                          className="text-right total-color"
                          style={{ fontWeight: "bold" }}
                        >
                          $
                          {numberWithCommas(
                            (
                              (priceObj?.shipping_amount || 0) +
                              (productData || []).reduce((pre, item) => {
                                return (

                                  item?.selectedAditivePrice
                                    ? Number(pre) +
                                    Number(
                                      (item?.selectedAditivePrice +
                                        item?.actualProdcutPrice) *
                                      item.quantity
                                    )
                                    : Number(pre) +
                                    Number(
                                      item.quantity *
                                      item.actualProdcutPrice
                                    )
                                );
                              }, 0)
                            ).toFixed(2)
                          )}
                        </Col>
                      </Row>

                    </Col> */}
                    {/* } */}

                  </Row>
                </Col>
              </Row>
              {!checkoutScreen ? (
                <Row justify="end" style={{ marginBottom: "1rem" }}>
                  <Col
                    xl={18}
                    xs={22}
                    sm={22}
                    md={23}
                    lg={23}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    {isLoader ? (
                      <img src={LoaderGif} height={60} width={60} />
                    ) : (
                      <Button
                        style={{
                          backgroundColor: "#f57c00 ",
                          color: "#fff",
                          width: "30%",
                          border: "none",
                        }}
                        onClick={() => onSubmitCheckout()}
                      >
                        CHECKOUT
                      </Button>
                    )}
                  </Col>
                </Row>
              ) : (
                <Row justify="end" style={{ marginBottom: "1rem" }}>
                  <Col
                    xl={18}
                    xs={22}
                    sm={22}
                    md={23}
                    lg={18}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    {isPlaceOrder ? (
                      <img src={LoaderGif} height={60} width={60} />
                    ) : (
                      <Button
                        style={{
                          backgroundColor: "#f57c00 ",
                          color: "#fff",
                          width: "30%",
                          border: "none",
                        }}
                        onClick={() => placeOrder()}
                      >
                        PLACE ORDER
                      </Button>
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col >
      ) : (
        <Col span={24} style={{ marginTop: "3rem", marginBottom: "3rem" }}>
          <Row justify="start" align="middle">
            <Col span={13} className="text-center">
              <Empty description="Nothing to Show right now" />
            </Col>
            <Col
              span={13}
              className="text-center"
              style={{ marginTop: "1rem" }}
            >
              <Button
                style={{
                  backgroundColor: "#f57c00 ",
                  color: "#fff",
                  width: "50%",
                  border: "none",
                }}
                onClick={() => onbackCatalogScreen()}
              >
                ADD PRODUCTS TO CART
              </Button>
            </Col>
          </Row>
        </Col>
      )
      }
    </Row >
  );
}
